// MapComponent.jsx
import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './componentCss/MapComponent.css';

const MapComponent = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    if (mapRef.current && !mapInstanceRef.current) {
      mapInstanceRef.current = L.map(mapRef.current).setView([43.6047, 1.4442], 6);

      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 19,
      }).addTo(mapInstanceRef.current);

      const customIcon = L.divIcon({
        className: 'custom-div-icon',
        html: '<div class="map-dot"></div>',
        iconSize: [15, 15],
        iconAnchor: [7.5, 7.5],
      });

      L.marker([43.54705112364532, 1.5059445423297242], { icon: customIcon })
        .addTo(mapInstanceRef.current)
        .bindPopup('<strong>KOBOCT Labège</strong>');
    }
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return <div ref={mapRef} className="mapContainer" />;
};

export default MapComponent;
